import { useContext, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { useAuthContext } from "../../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { Sync } from "../../../SyncService";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";

const PrinterListing = ({ listOfPrinters }) => {
  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const navigate = useNavigate();

  const [loadingPrinter, setLoadingPrinter] = useState("");

  const isConnected = (printerName) =>
    printerName === business?.printer && business?.connected;

  const handleConnect = async (printerName) => {
    setLoadingPrinter(printerName);
    try {
      await business.setPrinter(printerName);
      triggerLogEvent(analytics, "printer_connected", { type: printerName });
      Sync(user.phone_number, navigate);
    } finally {
      setLoadingPrinter("");
    }
  };

  const handleDisconnect = async () => {
    setLoadingPrinter(business?.printer);
    try {
      await business.togglePrinter(false);
      triggerLogEvent(analytics, "printer_disconnected");
      Sync(user.phone_number, navigate);
    } finally {
      setLoadingPrinter("");
    }
  };

  return (
    <div className={styles.listingRoot}>
      <div className={styles.tableHeader}>
        <span className={styles.colName}>{I18n.printer_name}</span>
        <span className={styles.colStatus}>{I18n.status}</span>
        <span className={styles.colActions}>{I18n.actions}</span>
      </div>

      <div className={`${styles.tableBody} generic-scrollbar`}>
        {listOfPrinters.map((printerName) => {
          const connected = isConnected(printerName);
          const isLoading = loadingPrinter === printerName;
          return (
            <div key={printerName} className={styles.tableRow}>
              <span className={styles.colName}>{printerName}</span>
              <span className={styles.colStatus}>
                {connected ? I18n.connected : I18n.not_connected}
              </span>
              <span className={styles.colActions}>
                {isLoading ? (
                  <span className={styles.loadingContainer}>
                    <CircularProgress size={16} />
                  </span>
                ) : (
                  <button
                    type="button"
                    id={`printer_listing_${connected ? "disconnect" : "connect"}_${printerName}_btn`}
                    className={styles.actionBtn}
                    onClick={() =>
                      connected
                        ? handleDisconnect()
                        : handleConnect(printerName)
                    }
                  >
                    {connected ? I18n.disconnect : I18n.connect}
                  </button>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PrinterListing;
